import React, { useCallback, useEffect, useState } from "react";
import { Row, Col } from 'react-bootstrap';
import './index.scss';

import 'react-datepicker/dist/react-datepicker.css';

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

// import Monthly from "./Monthly";
import Yearly from "./Yearly";

import { useSelector, useDispatch } from 'react-redux';
import { getbubbleChartValue } from "../../../../../store/actions/dashboardAction";

const BubbleChart = () => {

    const landscapeChartValueResponse = useSelector((state) => state.dashboard.landscapeChartValue);

    const dispatch = useDispatch();

    const {
        domainId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const [activeTab] = useState("monthly"); // Initially set to "Monthly"
    const [chartData, setChartData] = useState([]);

    const fetchBubbleChart = useCallback(()=>{
        const orgParams = organizationId && organizationId.toLowerCase() !== "all" ? `&organization_id=${organizationId}` : ""
        const domainParams = domainId && domainId.toLowerCase() !== "all" ? `&domain=${domainId}` : ""
        const params = `${orgParams}${domainParams}&period=${activeTab}`
        dispatch(getbubbleChartValue(params))
    },[organizationId, domainId, activeTab, dispatch])

    useEffect(()=>{
        fetchBubbleChart()
    },[activeTab, fetchBubbleChart])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchBubbleChart()
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setTriggerStatsFetch, fetchBubbleChart]);

    useEffect(()=>{
        if(landscapeChartValueResponse !== null) {

            const xValues = [0.5, 0.5, 1.8, 1.8, 3.2, 3.2, 4.5, 4.5, 5.5, 5.5, 6.8, 6.8, 8.2, 8.2, 9.6, 9.6, 10.5, 10.5, 11.8, 11.8, 13.2, 13.2, 14.8, 14.8];
        
            const openPortsData = landscapeChartValueResponse?.stats?.open_port?.map((port, index) => {            
                return {
                    type: port?.name,
                    title: "Open Ports",
                    category: "openPorts",
                    name: port?.type,
                    color: "#078AFF",
                    strokeColor: index % 2 === 0 ? "#0064FF" : "#078AFF", // Alternate strokeColor
                    fillOpacity: index % 2 === 0 ? 0.5 : 0.8,            // Alternate fillOpacity
                    strokeWidth: index % 2 === 0 ? 1 : 0,                // Alternate strokeWidth
                    x: xValues[index] || 0,                           // Dynamic x-coordinate
                    y: 9.5,
                    value: port?.count,
                };
            }) || [];

            const sslCertificate = landscapeChartValueResponse?.stats?.ssl_certificate?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "SSL Certificates",
                    category: "sslCertificates",
                    name: port?.type,
                    color: "#078AFF",
                    strokeColor: index % 2 === 0 ? "#0064FF" : "#078AFF", // Alternate strokeColor
                    fillOpacity: index % 2 === 0 ? 0.5 : 0.8,            // Alternate fillOpacity
                    strokeWidth: index % 2 === 0 ? 1 : 0,                // Alternate strokeWidth
                    x: xValues[index] || 0,                           // Dynamic x-coordinate
                    y: 9.1,
                    value: port?.count,
                };
            }) || [];

            const technologies = landscapeChartValueResponse?.stats?.technology?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Technologies",
                    category: "technologies",
                    name: port?.type,
                    color: "#078AFF",
                    strokeColor: index % 2 === 0 ? "#0064FF" : "#078AFF", // Alternate strokeColor
                    fillOpacity: index % 2 === 0 ? 0.5 : 0.8,            // Alternate fillOpacity
                    strokeWidth: index % 2 === 0 ? 1 : 0,                // Alternate strokeWidth
                    x: xValues[index] || 0,                           // Dynamic x-coordinate
                    y: 8.7,
                    value: port?.count,
                };
            }) || [];

            const dnsRecord = landscapeChartValueResponse?.stats?.dns_record?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "DNS Records",
                    category: "dnsRecords",
                    name: port?.type,
                    color: "#078AFF",
                    strokeColor: index % 2 === 0 ? "#0064FF" : "#078AFF", // Alternate strokeColor
                    fillOpacity: index % 2 === 0 ? 0.5 : 0.8,            // Alternate fillOpacity
                    strokeWidth: index % 2 === 0 ? 1 : 0,                // Alternate strokeWidth
                    x: xValues[index] || 0,                           // Dynamic x-coordinate
                    y: 8.3,
                    value: port?.count,
                };
            }) || [];

            const webServer = landscapeChartValueResponse?.stats?.webserver?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Web Servers",
                    category: "webserver",
                    name: port?.type,
                    color: "#078AFF",
                    strokeColor: index % 2 === 0 ? "#D03360" : "#078AFF", // Alternate strokeColor
                    fillOpacity: index % 2 === 0 ? 0.5 : 0.8,            // Alternate fillOpacity
                    strokeWidth: index % 2 === 0 ? 1 : 0,                // Alternate strokeWidth
                    x: xValues[index] || 0,                           // Dynamic x-coordinate
                    y: 7.9,
                    value: port?.count,
                };
            }) || [];

            const ipAddress = landscapeChartValueResponse?.stats?.ip_address?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "IP Addresses",
                    category: "ipAddresses",
                    name: port?.type,
                    color: "#F66C93",
                    strokeColor: index % 2 === 0 ? "#0064FF" : "#F66C93", // Alternate strokeColor
                    fillOpacity: index % 2 === 0 ? 0.5 : 0.8,            // Alternate fillOpacity
                    strokeWidth: index % 2 === 0 ? 1 : 0,                // Alternate strokeWidth
                    x: xValues[index] || 0,                           // Dynamic x-coordinate
                    y: 7.3,
                    value: port?.count,
                };
            }) || [];

            const subDomains = landscapeChartValueResponse?.stats?.subdomain?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Subdomains",
                    category: "subDomains",
                    name: port?.type,
                    color: "#F66C93",
                    strokeColor: index % 2 === 0 ? "#0064FF" : "#F66C93", // Alternate strokeColor
                    fillOpacity: index % 2 === 0 ? 0.5 : 0.8,            // Alternate fillOpacity
                    strokeWidth: index % 2 === 0 ? 1 : 0,                // Alternate strokeWidth
                    x: xValues[index] || 0,                           // Dynamic x-coordinate
                    y: 6.9,
                    value: port?.count,
                };
            }) || [];

            const gitLeaks = landscapeChartValueResponse?.stats?.gitleak?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Git Leaks",
                    category: "gitLeaks",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 6.3,
                    value: port?.count,
                };
            }) || [];

            const jsSecrets = landscapeChartValueResponse?.stats?.js_secret?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Js secrets",
                    category: "jsSecrets",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 5.9,
                    value: port?.count,
                };
            }) || [];

            const sensitiveExposure = landscapeChartValueResponse?.stats?.sensitive_exposure?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Sensitive Exposure",
                    category: "sensitiveExposure",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 5.5,
                    value: port?.count,
                };
            }) || [];

            const subdomainTakeover = landscapeChartValueResponse?.stats?.subdomain_takeover?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Subdomain Takeovers",
                    category: "subdomainTakeovers",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 5.1,
                    value: port?.count,
                };
            }) || [];

            const cves = landscapeChartValueResponse?.stats?.cve?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "CVE's",
                    category: "cves",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 4.7,
                    value: port?.count,
                };
            }) || [];

            const cnvds = landscapeChartValueResponse?.stats?.cnvd?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "CNVD's",
                    category: "cnvds",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 4.3,
                    value: port?.count,
                };
            }) || [];

            const sslVulnerabilities = landscapeChartValueResponse?.stats?.ssl_vulnerability?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "SSL Vulnerabilities",
                    category: "sslVulnerabilities",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 3.9,
                    value: port?.count,
                };
            }) || [];

            const exposedPanel = landscapeChartValueResponse?.stats?.exposed_panel?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Exposed Panels",
                    category: "exposedPanel",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 3.5,
                    value: port?.count,
                };
            }) || [];

            const defaultLogin = landscapeChartValueResponse?.stats?.default_login?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Default Logins",
                    category: "defaultLogins",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 3.1,
                    value: port?.count,
                };
            }) || [];

            const misConfiguration = landscapeChartValueResponse?.stats?.misconfiguration?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Misconfigurations",
                    category: "misconfigurations",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 2.7,
                    value: port?.count,
                };
            }) || [];

            const otherVulnerabilities = landscapeChartValueResponse?.stats?.other_vulnerability?.map((port, index) => {
                return {
                    type: port?.name,
                    title: "Other Vulnerabilities",
                    category: "otherVulnerabilities",
                    name: port?.type,
                    color: index % 2 === 0 ? "#18E7F8" : "#00308B",
                    strokeColor: "0064FF", // Alternate strokeColor
                    fillOpacity: 0.5,
                    strokeWidth: 1,
                    x: xValues[index] || 0,
                    y: 2.3,
                    value: port?.count,
                };
            }) || [];

            const infoStealer = landscapeChartValueResponse?.stats?.botnet_leak?.map((port, index) => {            
                return {
                    type: port?.name,
                    title: "Infostealer",
                    category: "Infostealer",
                    name: port?.type,
                    color: "#F8181C",
                    strokeColor: index % 2 === 0 ? "#CD0900" : "#F8181C", // Alternate strokeColor
                    fillOpacity: index % 2 === 0 ? 0.5 : 0.8,            // Alternate fillOpacity
                    strokeWidth: index % 2 === 0 ? 1 : 0,                // Alternate strokeWidth
                    x: xValues[index] || 0,                           // Dynamic x-coordinate
                    y: 1.6,
                    value: port?.count,
                };
            }) || [];

            const leakedCredentials = landscapeChartValueResponse?.stats?.leaked_credential?.map((port, index) => {            
                return {
                    type: port?.name,
                    title: "Leaked Credentials",
                    category: "leakedCredentials",
                    name: port?.type,
                    color: "#F8181C",
                    strokeColor: index % 2 === 0 ? "#CD0900" : "#F8181C", // Alternate strokeColor
                    fillOpacity: index % 2 === 0 ? 0.5 : 0.8,            // Alternate fillOpacity
                    strokeWidth: index % 2 === 0 ? 1 : 0,                // Alternate strokeWidth
                    x: xValues[index] || 0,                           // Dynamic x-coordinate
                    y: 1.1,
                    value: port?.count,
                };
            }) || [];

            const ransomwareLeak = landscapeChartValueResponse?.stats?.ransomware_leak?.map((port, index) => {            
                return {
                    type: port?.name,
                    title: "Ransomware Leaks",
                    category: "ransomwareLeaks",
                    name: port?.type,
                    color: "#F8181C",
                    strokeColor: index % 2 === 0 ? "#CD0900" : "#F8181C", // Alternate strokeColor
                    fillOpacity: index % 2 === 0 ? 0.5 : 0.8,            // Alternate fillOpacity
                    strokeWidth: index % 2 === 0 ? 1 : 0,                // Alternate strokeWidth
                    x: xValues[index] || 0,                           // Dynamic x-coordinate
                    y: 0.7,
                    value: port?.count,
                };
            }) || [];

            const data = [...openPortsData, ...sslCertificate, ...technologies, ...dnsRecord, ...webServer, ...ipAddress, ...subDomains, ...gitLeaks, ...jsSecrets,
                ...sensitiveExposure, ...subdomainTakeover, ...cves, ...cnvds, ...sslVulnerabilities, ...exposedPanel, ...defaultLogin, ...misConfiguration,
                ...otherVulnerabilities, ...infoStealer, ...leakedCredentials, ...ransomwareLeak
            ]
            setChartData(data)
        }
    },[landscapeChartValueResponse])

    return (

        <div className="bg-white-with-shadow p-4 mt-4">
            <div className="dashboard-box-container">
                <p className="heading font-bold">Discovered and Validated Threats</p>
            </div>            
            <div className="d-flex mt-3">
                <div className="discovered-date-selection d-flex mt-1">
                    {/* <p className={`rounded text-center ${activeTab === "monthly" ? "active" : ""}`}
                        onClick={() => setActiveTab("monthly")}>
                        Monthly
                    </p>
                    <p className={`rounded text-center ${activeTab === "yearly" ? "active" : ""}`}
                        onClick={() => setActiveTab("yearly")}>
                        Yearly
                    </p> */}
                    <p className="rounded text-center active">
                        Monthly
                    </p>
                </div>
            </div>

            <div className="discovered-digital d-flex gap-3 mt-3">
                <p><span className="digital digital-blue"></span>Digital Footprints</p>
                <p><span className="assets assets-pink"></span>Assets</p>
                <p><span className="vulnerabilities vulnerabilities-skyblue"></span>Vulnerabilities</p>
                <p><span className="dark-web darkweb-red"></span>Dark Web</p>
                <p className="border-custom"></p>
                <p><span className="resolved resolved-violet"></span>Resolved</p>
            </div>
            <Row>
                <Col lg={3}>
                    <div className="bg-grey p-4 d-flex">
                        <h5 className="vulnerabilities-type">
                            DIGITAL FOOTPRINTS
                        </h5>
                        <div className="ms-3">
                            <p>Open Ports</p>
                            <p>SSL Certificates</p>
                            <p>Technologies</p>                            
                            <p>DNS Records</p>
                            <p>Web Servers</p>
                        </div>
                    </div>

                    <div className="bg-white-Ipaddress p-4 d-flex">
                        <h5 className="vulnerabilities-type">
                            ASSETS
                        </h5>
                        <div className="ms-3">
                            <p>IP Address</p>
                            <p>Subdomains</p>
                        </div>
                    </div>
                    <div className="bg-grey p-4 mt-2 d-flex">
                        <h5 className="vulnerabilities-type">
                            EXPOSURES & VULNERABILITIES
                        </h5>
                        <div className="ms-3"> 
                            <p>Git Leaks</p>                           
                            <p>JS Secrets</p>
                            <p>Sensitive Exposures</p>
                            <p>Subdomain Takeovers</p>
                            <p>CVE's</p>
                            <p>CNVD's</p>                            
                            <p>SSL Vulnerabilities</p>
                            <p>Exposed Panels</p>
                            <p>Default Logins</p>
                            <p>Misconfigurations</p>
                            <p>Other Vulnerabilities</p>
                        </div>
                    </div>
                    <div className="bg-grey p-4 mt-2 d-flex">
                        <h5 className="vulnerabilities-type">
                            DARK WEB
                        </h5>
                        <div className="ms-3">
                            <p>Infected by Infostealer</p>
                            <p>Leaked Credentials</p>
                            <p>Ransomware Leaks</p>
                        </div>
                    </div>
                </Col>
                <Col lg={9}>
                        {/* {activeTab === "monthly" && <Monthly chartData={chartData}/>} */}
                        {activeTab === "monthly" && <Yearly chartData={chartData}/>}            
                </Col>
            </Row>

        </div>

    )

};

export default BubbleChart;
